import { PropsWithChildren, useContext } from "react";
import { useErrorMessage, useSetErrorMessage } from "../../../generic-error";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faFileAlt } from "@fortawesome/free-solid-svg-icons";
import { RegulationsContext } from ".";
import { Link } from "react-router-dom";
import { externalRedirectUrl } from "../../../page-redirect";
import { IMAGE_HOST } from "../../../../server/config";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";

function TransmedProcessSlide({
  children,
  className,
  ...rest
}: PropsWithChildren<any>) {
  const setErrorMessage = useSetErrorMessage();
  const errorMessage = useErrorMessage();
  const regulations = useContext(RegulationsContext);

  const { width } = useWindowDimensions();

  return (
    <div className="transmed-process-slide surface transmed-process-announcement">
      <div className={"inline-scrollbar y"}>
        <Link
          to={externalRedirectUrl(IMAGE_HOST + regulations)}
          className="primary button text"
          style={{
            zIndex: 2,
            marginTop: "-3px",
            marginBottom: "var(--gap-small)",
            marginRight: width > 500 ? "20px" : "",
            alignSelf: width > 500 ? "flex-end" : "center",
          }}
        >
          <FontAwesomeIcon icon={faFileAlt} /> Regulament
        </Link>
        {errorMessage.length > 0 && (
          <div
            className="surface"
            style={{
              backgroundColor: "red",
              position: "sticky",
              top: 0,
              zIndex: 2,
              color: "white",
              marginBottom: "var(--gap-medium)",

              alignSelf: "stretch",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              boxShadow: "var(--box-shadow-xs)",
            }}
          >
            {errorMessage}
            <button
              className="primary button text"
              style={{
                color: "white",
              }}
              onClick={() => setErrorMessage("")}
            >
              <FontAwesomeIcon icon={faClose} />
            </button>
          </div>
        )}
        <div className={"content " + (className ?? "")} {...rest}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default TransmedProcessSlide;
